// @flow

import React, {Component} from 'react'
import css from './Search.css'
import {DEFAULT_TEXTS} from '../../common/constants'

type Props = {
  keyword: ?string,
  onChange: Function,
  onSearch: Function,
  sizeL: boolean,
  placeholderText?: string,
  instructionText?: string,
}

class Search extends Component {
  props: Props

  handleValueChange = (e: any) => {
    const {onChange} = this.props
    const value = e.target.value
    onChange(value)
  }

  render() {
    const {keyword, onSearch, sizeL, placeholderText, instructionText} = this.props

    return (
      <div className={css.component}>
        <div className={css.wrapper}>
          <input
            autoFocus={true}
            value={keyword}
            onChange={e => this.handleValueChange(e)}
            onKeyPress={event => {
              if (event.key === 'Enter') {
                event.preventDefault()
                onSearch(keyword)
              }
            }}
            className={sizeL ? css.field : css.fieldShort}
            type="text"
            placeholder={placeholderText ? placeholderText : DEFAULT_TEXTS.searchPlaceholder}
          />
          <button
            className={sizeL ? css.button : css.buttonSmaller}
            onClick={() => onSearch(keyword)}
          />
        </div>
        {sizeL && (
          <p className={css.text}>
            {instructionText
              ? instructionText
              : DEFAULT_TEXTS.searchInstruction
            }
          </p>
        )}
      </div>
    )
  }
}

export default Search



// WEBPACK FOOTER //
// ./src/common/components/Search.js